<template>
  <generic-container
    :title="$t('outbox templates')"
    icon="arrow alternate circle up outline"
    :configurable="true"
    v-bind:configure_modal="configure_modal"
    :header_buttons="header_buttons"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("provider") }}</th>
          <th>{{ $t("template") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <outbox-modal ref="outbox_modal" @deleted="refresh" @success="refresh" />
    <message-modal ref="message_modal" />
  </generic-container>
</template>

<script>
// import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import OutboxModal from "./outbox_modal/OutboxModalIndex.vue";
import MessageModal from "./message_modal/Index.vue";
import { init_ajax_data_datables, enterprise_setup } from "@/utils";
import { truncate } from "lodash";
// import filters from "@/filters";

export default {
  name: "OutboxIndex",
  components: {
    "generic-container": GenericContainer,
    OutboxModal,
    MessageModal,
  },
  data() {
    return {
      configure_modal: ConfigureModal,
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
        {
          icon: "blue add",
          tooltip: this.$t("add"),
          click: this.add,
        },
      ],
      datatable: {},
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    refresh() {
      this.init();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function (row) {
            return row.name;
          },
        },
        {
          data: function (row) {
            return `<h3 class="ui header">
  ${row.out_provider.name}
  <div class="sub header">${row.out_provider.library}</div>
</h3>`;
          },
        },
        {
          data: function (row) {
            // let m = "<ul>";
            // if (row.)
            // return JSON.stringify(row.setup.message);
            return `<textarea readonly style="width:100%">${truncate(
              row.setup.message,
              {
                length: 75,
              },
            )}</textarea>`;
            // return m;
          },
        },
        {
          data: function (row) {
            return `<div class="ui orange mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.edit_template', this);"><i class="write icon"></i></div>
                    <div class="ui green mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.send_message', this);"><i class="plus icon"></i></div>
                    <div class="ui blue mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.template_log', this);"><i class="list ul icon"></i></div>`;
          },
        },
      ];

      let onSelect = () => {
        // console.log(data);
        // vm.$refs.outbox_modal.show_modal(data);
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["outbox url"],
        columns,
        onSelect,
      );
    },
    add() {
      this.$refs.outbox_modal.show_modal();
    },
  },
  created() {
    let vm = this;
    window.jQuery(window).on("modul.send_message", function (e, element) {
      let uuid = window.jQuery(element).data("uuid");
      vm.$refs.message_modal.show_modal({
        template_uuid: uuid,
      });
    });

    window.jQuery(window).on("modul.edit_template", function (e, element) {
      let uuid = window.jQuery(element).data("uuid");
      vm.$refs.outbox_modal.show_modal(uuid);
    });

    window.jQuery(window).on("modul.template_log", function (e, element) {
      let uuid = window.jQuery(element).data("uuid");
      vm.$router.push({
        name: "OutboxMessages",
        query: { i: uuid },
      });
    });
  },
  mounted() {
    let vm = this;
    vm.init();
  },
};
</script>
